import { ComponentProjectRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { CreateComponentProjectRequest } from "./create-component-project/CreateComponentProjectRequest";
import { CreateComponentProjectResponse } from "./create-component-project/CreateComponentProjectResponse";
import { GetComponentProjectRequest } from "./get-component-project/GetComponentProjectRequest";
import { GetComponentProjectResponse } from "./get-component-project/GetComponentProjectResponse";
import { UpdateComponentProjectRequest } from "./update-component-project/UpdateComponentProjectRequest";
import { UpdateComponentProjectResponse } from "./update-component-project/UpdateComponentProjectResponse";

export const useGetComponentProject = () =>
  useRestResourceHook<GetComponentProjectRequest, GetComponentProjectResponse>(
    (request) => ComponentProjectRestResource.getComponentProject(request),
  );

export const useUpdateComponentProject = () =>
  useRestResourceHook<
    UpdateComponentProjectRequest,
    UpdateComponentProjectResponse
  >((request) => ComponentProjectRestResource.updateComponentProject(request));

export const useCreateComponentProject = () =>
  useRestResourceHook<
    CreateComponentProjectRequest,
    CreateComponentProjectResponse
  >((request) => ComponentProjectRestResource.createComponentProject(request));
